// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.



export const environment = {
  production: false,
  enableLogs: true,
  patientService: `registration-dev/`,
  coverageService: `coverage-dev/`,
  reportService: `report-dev/`,
  clientId:'dental-frontend',
  clientRoot: 'https://evm-dev.rcm-cec.com/',
  userService: `user-service-dev/`,
  batchJob: 'batch-job-dev/',
  stsAuthority: 'https://keycloak-dev.rcm-cec.com/realms/dental',
  apiRoot: 'https://gateway.rcm-cec.com/',
  websocketUrl: 'wss://registration-dev.rcm-cec.com/registration/ws',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
